export type VideoAdsState = {
  last_video_view_ts?: number;
  last_interstitial_view_ts?: number;

  rv_view_timestamps?: number[];
  inter_view_timestamps?: number[];

  rv_losses_since_last_attempt?: number;
  inter_levels_since_last_show?: number;
};

const STORAGE_KEY = 'block_rush_video_ads_state';

function normalizeTimestamps( v: unknown ): number[]
{
  if ( !Array.isArray( v ) ) return [];
  const out: number[] = [];
  for ( const item of v )
  {
    if ( typeof item === 'number' && Number.isFinite( item ) && item > 0 )
    {
      out.push( Math.floor( item ) );
    }
  }
  return out;
}

function normalizeCounter( v: unknown, fallback: number ): number
{
  const n = typeof v === 'number' ? v : Number( v );
  if ( !Number.isFinite( n ) ) return fallback;
  return Math.max( 0, Math.floor( n ) );
}

export function loadVideoAdsState(): VideoAdsState
{
  const raw = localStorage.getItem( STORAGE_KEY );
  if ( !raw )
  {
    const initial: VideoAdsState = {
      last_video_view_ts: 0,
      last_interstitial_view_ts: 0,
      rv_view_timestamps: [],
      inter_view_timestamps: [],
      rv_losses_since_last_attempt: 0,
      inter_levels_since_last_show: 0,
    };
    saveVideoAdsState( initial );
    return initial;
  }

  try
  {
    const parsed: any = JSON.parse( raw );
    const normalized: VideoAdsState = {
      last_video_view_ts: normalizeCounter( parsed?.last_video_view_ts, 0 ),
      last_interstitial_view_ts: normalizeCounter( parsed?.last_interstitial_view_ts, 0 ),
      rv_view_timestamps: normalizeTimestamps( parsed?.rv_view_timestamps ),
      inter_view_timestamps: normalizeTimestamps( parsed?.inter_view_timestamps ),
      rv_losses_since_last_attempt: normalizeCounter( parsed?.rv_losses_since_last_attempt, 0 ),
      inter_levels_since_last_show: normalizeCounter( parsed?.inter_levels_since_last_show, 0 ),
    };
    saveVideoAdsState( normalized );
    return normalized;
  }
  catch
  {
    const fallback: VideoAdsState = {
      last_video_view_ts: 0,
      last_interstitial_view_ts: 0,
      rv_view_timestamps: [],
      inter_view_timestamps: [],
      rv_losses_since_last_attempt: 0,
      inter_levels_since_last_show: 0,
    };
    saveVideoAdsState( fallback );
    return fallback;
  }
}

export function saveVideoAdsState( state: VideoAdsState ): void
{
  localStorage.setItem( STORAGE_KEY, JSON.stringify( state ) );
}

export function updateVideoAdsState( fn: ( current: VideoAdsState ) => VideoAdsState ): VideoAdsState
{
  const current = loadVideoAdsState();
  const next = fn( current );
  saveVideoAdsState( next );
  return next;
}
